import { makeQueryStringDync, errorServeiceHandler, makeQueryFormDataDyn} from '../helper'
const actions = {
    payDPOCustomer: (context) => {
    let url = '/subscriber/v1/cart/checkout'
    return new Promise( (resolve, reject) => {
      fetch(context.getters.baseUrl + url, {
        method: 'POST'
      })
      .then(errorServeiceHandler)
      .then((response) => {
        return response.text()
      }).then((data) => {
        if (context.getters.getMode == "development") {
          resolve()
        }
        else {
          resolve(data)
        }
      }).catch((error) => {
        if (context.getters.getMode == "development") {
          resolve()
          return
        }
        reject(error)
      });
    });
  },
  payLCOCustomer: (context, formData) => {
    let url = '/subscriber/v1/payment/init'
    return new Promise( (resolve, reject) => {
      let queryStr = makeQueryFormDataDyn(formData)
      fetch(context.getters.baseUrl + url, {
        method: 'POST',
        body: queryStr
      })
      .then(errorServeiceHandler)
      .then((response) => {
        return response.json()
      }).then((data) => {
        if (context.getters.getMode == "development") {
          resolve()
        }
        else {
          resolve(data)
        }
      }).catch((error) => {
        if (context.getters.getMode == "development") {
          resolve()
          return
        }
        reject(error)
      });
    });
  },
  payBillCloudCustomer: (context, formData) => {
    let url = 'https://v3-uat.billcloud.in:9999/me-imcl/external/initiatePayment'
    return new Promise( (resolve, reject) => {
      let queryStr = makeQueryFormDataDyn(formData)
      fetch(url, {
        method: 'POST',
        body: queryStr
      })
      .then(errorServeiceHandler)
      .then((response) => {
        return response.json()
      }).then((data) => {
        resolve(data)
      }).catch((error) => {
        reject(error)
      });
    });
  },
  payRenewLCOCustomer: (context, formData) => {
    let url = '/subscriber/v1/billgenerate/init'
    return new Promise( (resolve, reject) => {
      fetch(context.getters.baseUrl + url, {
        method: 'POST',
        body: formData
      })
      .then(errorServeiceHandler)
      .then((response) => {
        return response.json()
      }).then((data) => {
        resolve(data)
      }).catch((error) => {
        reject(error)
      });
    });
  }
};

export default {
    actions
};


// WEBPACK FOOTER //
// ./src/store/modules/payment.js